import React, { Component } from 'react';

import { ProgressBar, Table } from 'react-bootstrap';
import { getAmenityTextureUrl, getBedTextureUrl, getCardTextureUrl, getFactionTextureUrl } from '../Common/TextureTools';

import './decks.css'

export default class Decks2d extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        let gameData = this.props.gameData;
        if (this.props.isPreGameStart) return <></>
        let guestDeckCount = gameData.guest_deck.length;
        let discardDeckCount = gameData.discard_deck.length;
        let total = guestDeckCount + discardDeckCount;

        return (
            <div className={'deck-holder'}>
                <ProgressBar className={'deck-2d-bar'}>
                    <ProgressBar variant={'honored'}
                                 min={0}
                                 max={total}
                                 now={guestDeckCount}
                                 key={1}
                                 label={guestDeckCount}
                    />
                    <ProgressBar variant={'dread'}
                                 min={0}
                                 max={total}
                                 now={discardDeckCount}
                                 key={2}
                                 label={discardDeckCount}
                    />
                </ProgressBar>
            </div>
        );
    }
}
